module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-24.58752ab1.jpg";